<template>
  <div class="bill-product-table">
    <label class="product-label"> Danh sách sản phẩm </label>

    <div v-if="isIndependent" class="refund-product-picker mb-3">
      <BillSaleProductSearchSelect
        :store-id="billModel.storeId"
        :bill-type="billModel.billType"
        :disabled="isDisabled"
        :allow-out-of-stock="true"
        :imei-search-status="IMEI_STATUS_SALED"
        @select="onSelectIndependentProduct"
      />
    </div>

    <div class="refund-product-toolbar">
      <b-form-input
        class="refund-product-search"
        :value="searchText"
        @input="onSearchInput"
        placeholder="Tìm theo tên / mã / barcode / IMEI…"
        :disabled="isDisabled"
        autocomplete="off"
      />
      <div v-if="selectedCount > 0" class="refund-product-bulk">
        <span class="refund-product-selected-label">
          Đã chọn {{ selectedCount }} sản phẩm
        </span>
        <b-button
          size="sm"
          variant="primary"
          :disabled="isDisabled"
          @click="keepOnlySelected"
        >
          Chỉ giữ lại sản phẩm đã chọn ({{ selectedCount }})
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          :disabled="isDisabled"
          @click="deleteSelected"
        >
          Xóa sản phẩm đã chọn ({{ selectedCount }})
        </b-button>
      </div>
    </div>

    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th class="header-color text-center" style="width: 3%">
            <b-form-checkbox
              :checked="allDisplayedSelected"
              :indeterminate="someDisplayedSelected && !allDisplayedSelected"
              :disabled="isDisabled || displayedMainItems.length === 0"
              @change="toggleSelectAll"
            />
          </th>
          <th class="header-color text-center">STT</th>
          <th class="header-color text-center">Sản phẩm</th>
          <th class="header-color text-center">Số lượng</th>
          <th class="header-color text-center">Giá</th>
          <th class="header-color text-center">Chiết khấu</th>
          <th class="header-color text-center">Thành tiền</th>
          <th></th>
        </tr>
      </thead>
      <tbody
        v-for="productItem in displayedBillItems"
        :key="`${productItem.itemType}-${productItem.id}`"
      >
        <td class="text-center" style="width: 3%">
          <b-form-checkbox
            v-if="isItemMainDisplay(productItem.itemType)"
            :checked="isMainSelected(productItem.id)"
            :disabled="isDisabled"
            @change="toggleSelect(productItem.id)"
          />
        </td>
        <td class="text-center" style="width: 4%">
          <span
            class="font-weight-bolder"
            v-if="isItemMainDisplay(productItem.itemType)"
            >{{ productItem.stt }}</span
          >
          <span v-else>
            <i
              v-if="isItemAttachDisplay(productItem.itemType)"
              class="fas fa-tags"
            ></i>
            <i v-else class="fas fa-gift"></i>
          </span>
        </td>
        <td style="width: 30%; padding-top: 20px; padding-bottom: 20px">
          <div style="display: flex; gap: 8px; align-items: center">
            <ProductImage :src="productItem.imageUrl || productItem.productImageUrl" />
            <div>
              <p class="m-0" style="font-style: italic">
                ({{ productItem.barCode }})
              </p>
              <p class="m-0" style="font-weight: 500">
                {{ productItem.productCode }}
              </p>
              <p class="m-0 font-weight-bolder">
                {{ productItem.productName }}
              </p>
              <b-form-input
                v-if="
                  isIndependent &&
                  !isUpdate &&
                  isItemMainDisplay(productItem.itemType) &&
                  productItem.productType === PRODUCT_TYPE.PRODUCT_IMEI
                "
                size="sm"
                class="mt-1 w-100"
                placeholder="Nhập IMEI"
                :value="productItem.imeiCode"
                :disabled="isDisabled"
                @input="onEditImei(productItem, $event)"
              />
              <ImeiDisplay
                v-else-if="productItem.productType === PRODUCT_TYPE.PRODUCT_IMEI"
                :imei="productItem.imeiCode"
              />
              <div
                class="table-responsive"
                v-show="
                  productItem.comboItems !== undefined &&
                  productItem.comboItems.length > 0
                "
              >
                <table>
                  <tr
                    v-for="(items, i) in productItem.comboItems"
                    :key="i"
                    style="border-top: 1px solid gray"
                  >
                    <td style="border: none">
                      <i style="color: rgb(24, 28, 50)" class="fas fa-cube"></i>
                    </td>
                    <td style="border: none; width: -webkit-fill-available">
                      {{ items.productName }}
                      <i style="font-size: unset; color: unset"
                        >({{ convertPrice(items.sellingPrice) }})</i
                      >
                    </td>
                    <td style="border: none">{{ items.quantity }}</td>
                  </tr>
                </table>
              </div>
              <div v-if="isItemMainDisplay(productItem.itemType)">
                <div v-show="productItem.note">
                  <b-button
                    size="sm"
                    disabled
                    style="color: black; cursor: auto"
                    class="mr-1 font-italic btn-hidden"
                    :id="`popover-note-${productItem.id}`"
                  >
                    Ghi chú:
                  </b-button>
                  <span class="text-note"> {{ productItem.note }}</span>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td class="td-middle text-right" style="width: 10%">
          <BInputNumber
            v-if="isIndependent && isItemMainDisplay(productItem.itemType)"
            size="sm"
            input-class="w-100"
            placeholder="SL"
            :value="productItem.quantity"
            :disabled="isDisabled"
            @valueChange="onEditQuantity(productItem, $event)"
          />
          <div v-else>
            {{ productItem.quantity }}
          </div>
        </td>
        <td
          class="td-middle text-right"
          style="
            width: 15%;
            position: relative;
            padding-top: 2px;
            padding-bottom: 2px;
          "
        >
          <BInputNumber
            v-if="isIndependent && isItemMainDisplay(productItem.itemType)"
            size="sm"
            input-class="w-100"
            placeholder="Đơn giá"
            :value="productItem.sellingPrice"
            :disabled="isDisabled"
            @valueChange="onEditPrice(productItem, $event)"
          />
          <div v-else>
            {{ convertPrice(productItem.sellingPrice) }}
          </div>
          <span
            v-if="
              !isIndependent &&
              (productItem.discountAmount ||
                calculateApplyBillDiscountAmount(productItem))
            "
            class="text-muted small"
            style="
              position: absolute;
              right: 10px;
              white-space: nowrap;
              font-weight: 600;
            "
          >
            Giá sau giảm:<br />
            {{ convertPrice(calculateAfterDiscountAmount(productItem)) }}
          </span>
        </td>
        <td class="td-middle text-right" style="width: 20%; position: relative">
          <BInputNumber
            v-if="isIndependent && isItemMainDisplay(productItem.itemType)"
            size="sm"
            input-class="w-100"
            placeholder="Chiết khấu"
            :value="productItem.discountAmount"
            :disabled="isDisabled"
            @valueChange="onEditDiscount(productItem, $event)"
          />
          <div v-else>
            <span>{{ convertPrice(productItem.discountAmount) }} </span>
            ({{ DISCOUNT_AMOUNT_TYPE_NAME[productItem.discountType] }})
          </div>
          <span
            v-if="!isIndependent && calculateApplyBillDiscountAmount(productItem)"
            class="text-muted small"
            style="
              position: absolute;
              right: 10px;
              white-space: nowrap;
              font-weight: 600;
            "
          >
            Giảm tổng hóa đơn:<br />
            {{ convertPrice(calculateApplyBillDiscountAmount(productItem)) }}
          </span>
        </td>
        <td class="td-middle text-right" style="width: 16%; position: relative">
          <span
            v-if="
              isItemMainDisplay(productItem.itemType) ||
              isItemAttachDisplay(productItem.itemType)
            "
          >
            {{ convertPrice(calculateTotalAmountBillItems(productItem)) }}
          </span>
          <span
            v-if="calculateApplyBillDiscountAmount(productItem)"
            class="text-muted small"
            style="
              position: absolute;
              top: 55%;
              right: 10px;
              white-space: nowrap;
              font-weight: 600;
            "
          >
            Sau tổng giảm<br />
            {{ convertPrice(calculateFinalAmountBillItem(productItem)) }}
          </span>
        </td>
        <td class="td-middle" style="width: 5%">
          <div class="d-flex justify-content-center">
            <b-dropdown
              size="sm"
              no-caret
              right
              v-if="productItem.itemType === 1"
              :disabled="isDisabled"
            >
              <template slot="button-content">
                <i
                  style="font-size: 1rem; padding-right: 0px"
                  class="flaticon2-settings"
                ></i>
              </template>
              <b-dropdown-item @click="onShowPrivateNote(productItem)">
                <span style="color: #3f4254; font-size: 12px">
                  <i style="font-size: 1rem" class="flaticon2-notepad"></i>
                  &nbsp; Thêm ghi chú
                </span>
              </b-dropdown-item>
              <b-dropdown-item @click="returnOnlyThis(productItem)">
                <span style="color: #3f4254; font-size: 12px">
                  <i
                    style="font-size: 1rem; color: #1bc5bd"
                    class="flaticon2-check-mark"
                  ></i>
                  &nbsp; Chỉ trả sản phẩm này
                </span>
              </b-dropdown-item>
              <b-dropdown-item @click="showDeleteAlert(productItem)">
                <span style="color: #3f4254; font-size: 12px">
                  <i
                    style="font-size: 1rem; color: #d33"
                    class="flaticon2-rubbish-bin-delete-button"
                  ></i>
                  &nbsp; Xóa
                </span>
              </b-dropdown-item>
            </b-dropdown>
            <b-dropdown size="sm" no-caret right v-else :disabled="isDisabled">
              <template slot="button-content">
                <i style="font-size: 1rem" class="flaticon2-settings pr-0"></i>
              </template>
              <b-dropdown-item @click="showDeleteAlert(productItem)">
                <span style="color: #3f4254; font-size: 12px">
                  <i
                    style="font-size: 1rem; color: #d33"
                    class="flaticon2-rubbish-bin-delete-button"
                  ></i>
                  &nbsp; Xóa
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </td>
      </tbody>
      <tfoot>
        <tr>
          <th style="text-align: end" colspan="6">Tổng :</th>
          <td style="text-align: right; padding: 0px 20px; font-weight: 600">
            {{ formattedTotalPrice }}
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
    <BillNoteModal
      ref="bill-note-modal"
      :productName="itemChoice.productName"
      :note="itemChoice.note"
      v-on:addNote="onChangeNote"
    />
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import debounce from 'debounce';
import { minLength } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { DISCOUNT_AMOUNT_TYPE_NAME } from '@/utils/enum-name';
import calculateMixin from '@/view/mixins/calculate.mixins.js';
import BillNoteModal from './BillNoteModal.vue';
import { PRODUCT_TYPE, ITEM_TYPE, AMOUNT_TYPE } from '@/utils/enum';
import { TIME_TRIGGER } from '@/utils/constants';
import ProductImage from '@/view/components/products/ProductImage.vue';
import ImeiDisplay from '@/view/components/imeis/ImeiDisplay.vue';
import BillSaleProductSearchSelect from './BillSaleProductSearchSelect.vue';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';
import {
  makeToastFaile,
  convertPrice,
  calculateDiscountAmount,
  removeAccents,
} from '@/utils/common';
import { BILL_ITEM_TYPE } from '../../../utils/enum';

export default {
  props: {
    billModel: Object,
    // Phiếu trả hàng độc lập: cho thêm sản phẩm tùy ý + nhập tay giá/số lượng/chiết khấu.
    isIndependent: {
      type: Boolean,
      default: false,
    },
    // Đang cập nhật hóa đơn trả (không phải tạo mới): khóa sửa IMEI để tránh phá vỡ liên kết imeiId.
    isUpdate: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [validationMixin, calculateMixin],
  validations: {
    itemChoice: {
      imeiCode: {
        minLength: minLength(3),
      },
    },
  },
  data() {
    return {
      PRODUCT_TYPE,
      DISCOUNT_AMOUNT_TYPE_NAME,
      // Tìm IMEI ĐÃ BÁN (IMEI_STATUS.SALED = 2) khi trả hàng — IMEI không còn tồn trong kho.
      IMEI_STATUS_SALED: 2,
      searchText: '',
      selectedIds: [],
      isOpenProductSearch: false,
      tempIdSeq: 0,
      validateDiscountArr: [],
      messageErrorDiscount: 'CK vượt giá trị SP',
      DISCOUNT_AMOUNT_TYPE: AMOUNT_TYPE,
      itemChoice: {
        id: 0,
        name: '',
        productId: '',
        imeiCode: '',
        price: 0,
        quantity: 0,
        discount: 0,
        totalPrice: 0,
      },
    };
  },
  components: {
    BillNoteModal,
    ProductImage,
    ImeiDisplay,
    BillSaleProductSearchSelect,
    BInputNumber,
  },
  created() {
    this.applySearch = debounce((value) => {
      this.searchText = value || '';
    }, TIME_TRIGGER);
  },
  computed: {
    displayedBillItems() {
      const term = removeAccents((this.searchText || '').trim().toLowerCase());
      if (!term) {
        return this.billModel.billItems;
      }
      const matchedMainIds = new Set();
      this.billModel.billItems.forEach((item) => {
        if (
          item.itemType === ITEM_TYPE.MAIN &&
          this.itemMatchesSearch(item, term)
        ) {
          matchedMainIds.add(item.id);
        }
      });
      return this.billModel.billItems.filter((item) =>
        item.itemType === ITEM_TYPE.MAIN
          ? matchedMainIds.has(item.id)
          : matchedMainIds.has(item.belongBillDetailId),
      );
    },
    displayedMainItems() {
      return this.displayedBillItems.filter(
        (item) => item.itemType === ITEM_TYPE.MAIN,
      );
    },
    selectedCount() {
      return this.selectedIds.length;
    },
    allDisplayedSelected() {
      return (
        this.displayedMainItems.length > 0 &&
        this.displayedMainItems.every((item) =>
          this.selectedIds.includes(item.id),
        )
      );
    },
    someDisplayedSelected() {
      return this.displayedMainItems.some((item) =>
        this.selectedIds.includes(item.id),
      );
    },
    totalBillItemsAmount() {
      return this.billModel.billItems
        .filter(this.isNonGiftItem)
        .reduce(
          (total, item) => total + this.calculateTotalAmountBillItems(item),
          0,
        );
    },
    formattedTotalPrice() {
      const totalPrice = this.totalBillItemsAmount;
      return convertPrice(totalPrice);
    },
    isDisabled() {
      return !this.billModel.storeId || !this.billModel.editable;
    },
  },
  methods: {
    convertPrice,
    // Thêm sản phẩm vào phiếu trả độc lập (kể cả sản phẩm dịch vụ).
    onSelectIndependentProduct(node) {
      if (!node) {
        return;
      }
      const productId = node.productId || node.id;
      const price = Number(node.sellingPriceMask ?? node.sellingPrice ?? 0);
      const newItem = {
        id: `new-${(this.tempIdSeq += 1)}`,
        productId,
        productName: node.productName || node.label,
        productCode: node.productCode,
        barCode: node.barCode,
        imageUrl: node.imageUrl || node.productImageUrl,
        productType: node.productType,
        sellingPrice: price,
        sellingPriceMask: price,
        quantity: 1,
        discountAmount: 0,
        discountType: AMOUNT_TYPE.MONEY,
        imeiCode: node.imeiCode || '',
        itemType: ITEM_TYPE.MAIN,
        comboItems: [],
        checked: true,
        isGetVat: true,
        note: '',
        repurchasePrice: 0,
        accessoryGroupId: '',
        accessoryGroupCode: '',
      };
      this.billModel.billItems.push(newItem);
    },
    onEditPrice(item, value) {
      const price = Number(value) || 0;
      item.sellingPrice = price;
      item.sellingPriceMask = price;
    },
    onEditQuantity(item, value) {
      item.quantity = Number(value) || 0;
    },
    onEditDiscount(item, value) {
      item.discountAmount = Number(value) || 0;
    },
    onEditImei(item, value) {
      item.imeiCode = (value || '').trim();
    },
    isItemMainDisplay(value) {
      return value === ITEM_TYPE.MAIN ? true : false;
    },
    isItemAttachDisplay(value) {
      return value === ITEM_TYPE.ATTACH ? true : false;
    },
    isNonGiftItem(item) {
      return item.itemType !== ITEM_TYPE.GIFT;
    },
    calculateApplyBillDiscountAmount(productItem) {
      const billDiscountAmount = calculateDiscountAmount(
        this.billModel.discountAmount,
        this.billModel.discountType,
        this.totalBillItemsAmount,
      );
      const totalAmountItem = this.calculateTotalAmountBillItems(productItem);
      const itemRate = totalAmountItem / this.totalBillItemsAmount;
      const applyBillDiscountAmount = billDiscountAmount * itemRate;
      return Math.round(applyBillDiscountAmount / 1000) * 1000;
    },
    calculateAfterDiscountAmount(item) {
      const sellingPrice = item.sellingPriceMask || 0;
      const discountAmount = this.calculateDiscountAmount(
        item.discountAmount || 0,
        item.discountType,
        sellingPrice,
      );

      const applyBillDiscountAmount =
        this.calculateApplyBillDiscountAmount(item);

      return sellingPrice - discountAmount - applyBillDiscountAmount;
    },
    calculateTotalAmountBillItems(item) {
      const sellingPrice = item.sellingPriceMask || 0;
      const quantity = item.quantity || 0;
      const discountAmount = this.calculateDiscountAmount(
        item.discountAmount || 0,
        item.discountType,
        sellingPrice,
      );
      let totalAmountItem = 0;

      if (quantity > 0) {
        totalAmountItem =
          (Number(sellingPrice) - Number(discountAmount)) * Number(quantity);
      }

      return totalAmountItem;
    },
    calculateFinalAmountBillItem(item) {
      const applyBillDiscountAmount =
        this.calculateApplyBillDiscountAmount(item);

      const itemAmount = this.calculateTotalAmountBillItems(item);
      return itemAmount - applyBillDiscountAmount * item.quantity;
    },
    showWarningAlert: function (text) {
      return Swal.fire({
        title: 'Xoá sản phẩm!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    },
    getIndexBillItems(id) {
      const index = this.billModel.billItems.findIndex(
        (item) => item.id === id,
      );
      if (index < 0) {
        makeToastFaile(`Không tìm thấy ${id} trong danh sách`);
        throw new Error(`Không tìm thấy ${id} trong danh sách`);
      }
      return index;
    },
    removeMainFromList(items, product) {
      let convertedItems = [];
      if (product.itemType === BILL_ITEM_TYPE.PRODUCT) {
        const attachItems = items.filter(
          (item) =>
            item.belongBillDetailId === product.id &&
            item.itemType === BILL_ITEM_TYPE.PRODUCT_PROMTION,
        );

        convertedItems = attachItems.map((item) => ({
          ...item,
          itemType: BILL_ITEM_TYPE.PRODUCT,
          belongBillDetailId: null,
        }));
      }
      const remaining = items.filter(
        (item) =>
          item.id !== product.id && item.belongBillDetailId !== product.id,
      );
      return [...remaining, ...convertedItems];
    },
    async showDeleteAlert(product) {
      const text = `Bạn muốn xoá sản phẩm ${product.productName} ra khỏi danh sách`;
      const alert = await this.showWarningAlert(text);

      if (alert.isConfirmed) {
        this.getIndexBillItems(product.id);
        this.billModel.billItems = this.removeMainFromList(
          this.billModel.billItems,
          product,
        );
        this.removeFromSelection(product.id);
        this.numberedBillItems();
      }
    },
    itemMatchesSearch(item, term) {
      return [item.productName, item.productCode, item.barCode, item.imeiCode]
        .filter((field) => field != null && field !== '')
        .some((field) =>
          removeAccents(String(field).toLowerCase()).includes(term),
        );
    },
    onSearchInput(value) {
      this.applySearch(value);
    },
    isMainSelected(id) {
      return this.selectedIds.includes(id);
    },
    toggleSelect(id) {
      const index = this.selectedIds.indexOf(id);
      if (index === -1) {
        this.selectedIds.push(id);
      } else {
        this.selectedIds.splice(index, 1);
      }
    },
    toggleSelectAll(checked) {
      const displayedIds = this.displayedMainItems.map((item) => item.id);
      if (checked) {
        this.selectedIds = [...new Set([...this.selectedIds, ...displayedIds])];
      } else {
        const displayedSet = new Set(displayedIds);
        this.selectedIds = this.selectedIds.filter(
          (id) => !displayedSet.has(id),
        );
      }
    },
    removeFromSelection(id) {
      const index = this.selectedIds.indexOf(id);
      if (index > -1) {
        this.selectedIds.splice(index, 1);
      }
    },
    async keepOnlyIds(ids, text) {
      const alert = await this.showWarningAlert(text);
      if (!alert.isConfirmed) {
        return;
      }
      const keepIds = new Set(ids);
      this.billModel.billItems = this.billModel.billItems.filter((item) =>
        item.itemType === ITEM_TYPE.MAIN
          ? keepIds.has(item.id)
          : keepIds.has(item.belongBillDetailId),
      );
      this.selectedIds = [];
      this.numberedBillItems();
    },
    keepOnlySelected() {
      if (this.selectedIds.length === 0) {
        return;
      }
      return this.keepOnlyIds(
        [...this.selectedIds],
        `Chỉ giữ lại ${this.selectedIds.length} sản phẩm đã chọn và xoá toàn bộ phần còn lại khỏi danh sách?`,
      );
    },
    returnOnlyThis(product) {
      return this.keepOnlyIds(
        [product.id],
        `Chỉ trả sản phẩm ${product.productName} và xoá toàn bộ sản phẩm còn lại khỏi danh sách?`,
      );
    },
    async deleteSelected() {
      if (this.selectedIds.length === 0) {
        return;
      }
      const ids = [...this.selectedIds];
      const alert = await this.showWarningAlert(
        `Bạn muốn xoá ${ids.length} sản phẩm đã chọn ra khỏi danh sách`,
      );
      if (!alert.isConfirmed) {
        return;
      }
      let items = this.billModel.billItems;
      ids.forEach((id) => {
        const product = items.find((item) => item.id === id);
        if (product) {
          items = this.removeMainFromList(items, product);
        }
      });
      this.billModel.billItems = items;
      this.selectedIds = [];
      this.numberedBillItems();
    },
    numberedBillItems() {
      let count = 1;
      return this.billModel.billItems.map((item) => {
        if (item.itemType === ITEM_TYPE.MAIN) {
          item.stt = count;
          count++;
        }
        return item;
      });
    },
    onShowPrivateNote(item) {
      this.itemChoice.id = item.id;
      this.itemChoice.productName = item.productName;
      const line = this.billModel.billItems.find(
        (row) =>
          row.id === item.id || String(row.id) === String(item.id),
      );
      const latestNote =
        line != null
          ? line.note == null
            ? ''
            : String(line.note)
          : item.note == null
            ? ''
            : String(item.note);
      this.$set(this.itemChoice, 'note', latestNote);
      setTimeout(() => {
        this.$refs['bill-note-modal'].showModal(latestNote);
      }, TIME_TRIGGER);
    },
    onChangeNote(note) {
      const billItem = this.billModel.billItems.find(
        (item) => item.id === this.itemChoice.id,
      );
      if (billItem) {
        this.$set(billItem, 'note', note == null ? '' : String(note));
      }
    },
  },
};
</script>

<style lang="scss">
.bill-product-table {
  .form-group {
    margin-bottom: 1rem;
  }
  table {
    td {
      vertical-align: middle !important;
    }
  }

  .header-color {
    color: rgb(24, 28, 50);
  }
  .text-note {
    font-size: 12px;
    font-style: italic;
    white-space: -moz-pre-wrap !important; /* Mozilla, since 1999 */
    white-space: -webkit-pre-wrap; /* Chrome & Safari */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    white-space: pre-wrap; /* CSS3 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    word-break: break-word;
    white-space: normal;
  }
  .btn-hidden {
    padding: 0px;
    border: none;
    background-color: transparent !important;
  }
  .btn-imei .btn.btn-secondary {
    background-color: #cac9db;
    border-color: #ced4da;
  }
  .product-label {
    font-weight: 500;
  }
  .refund-product-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin: 8px 0 12px;
  }
  .refund-product-search {
    max-width: 320px;
  }
  .refund-product-bulk {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }
  .refund-product-selected-label {
    font-size: 12px;
    font-weight: 600;
    color: #464e5f;
  }
}
</style>
